import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { uniformeModulo } from "src/app/aplicaciones-modulos/spyral/diccionarios/uniformeModule";
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { ClaveValorModel } from '../../model/claveValorModel';
import { ClothesEmployeSendModel } from '../../model/clothesEmployeSendModel';
import { ClothesModel } from '../../model/clothesModel';
import { ResponseInfoClothesEmployeModel } from "../../model/responseInfoClothesEmployeModel";


import { ClothesEmployeService } from "../../services/clothes-employe.service";

@Component({
  selector: 'app-cupo-prenda-empleado',
  templateUrl: './cupo-prenda-empleado.component.html',
  styleUrls: ['./cupo-prenda-empleado.component.css']
})
export class CupoPrendaEmpleadoComponent implements OnInit {

  mostrarFormulario: boolean = false;
  resposiveFull: string;
  resposiveClothesEmployeeFull: string;
  listaVacia: boolean = false;
  columnDefs: any[];//aggrid
  columnDefsClothesEmploye: any[];//aggrid
  rowData: ClothesModel[] = [];
  rowDataSend: ClothesEmployeSendModel[] = [];
  clothesModulo: any = {};
  clothesEmployeModulo: any = {};

  textoBuscarClothes: string;
  textoBuscarClothesEmploye: string;

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;
  formularioCantidad: FormGroup;
  formularioCarga: FormGroup;
  frameworkComponents: any;
  frameworkComponentsClothesEploye: any;
  gridApi: any;
  gridColumnApi: any;
  gridApiClothesEmploye: any;
  gridColumnApiClothesEmploye: any;
  rowSelection: any;
  rowSelectionClothesEmploye: any;
  loading:boolean = false;
  infoEmployeClothes: ResponseInfoClothesEmployeModel = new ResponseInfoClothesEmployeModel();
  seletedCLothesEmploye: ClothesEmployeSendModel;

  constructor(private fb: FormBuilder, private _util: UtilsService,
              private _clotheEmploye: ClothesEmployeService) { }

  ngOnInit() {

    this.clothesModulo = uniformeModulo;
    this.resposiveFull = this.clothesModulo.div.resposiveFull;

    this.clothesEmployeModulo = uniformeModulo;
    this.resposiveClothesEmployeeFull = this.clothesEmployeModulo.div.resposiveFull;

    this.formulario = this.fb.group({
      cedula: ['',[Validators.required, Validators.maxLength(10)]],
      codigo: [''],
      ccosto: [''],
      depart: [''],
      filial: [''],
      fullname: [''],
    });

    this.formularioCantidad = this.fb.group({
      cantd: ['',[Validators.required, Validators.maxLength(10)]],
      codbaan: [''],
      descrp: ['']
    });

    this.formularioCarga = this.fb.group({
      multipart: ['', [Validators.required]],
    });

    this.cargarGrid();
    this.cargarGridClotheEmploye();

  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'Cod BAAN',
        field: 'codBaan',
        filter: true,
        width: 100,
      },
      {
        headerName: 'Descripcion',
        field: 'descrp',
        filter: true,
        width: 200
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.addElementToClothesEmploye.bind(this),
          label: "Editar",
        }
      }
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';

  }

  cargarGridClotheEmploye() {
    this.columnDefsClothesEmploye = [
      {
        headerName: 'Cod BAAN',
        field: 'codbaan',
        filter: true,
        width: 150,
      },
      {
        headerName: 'Descripcion',
        field: 'descrp',
        filter: true,
        width: 350
      },
      {
        headerName: 'Cantidad',
        field: 'cantd',
        filter: true,
        width: 130
      },
      {
        headerName: 'Disponible',
        field: 'disp',
        filter: true,
        width: 130
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.addElementToClothes.bind(this),
          label: "Eliminar",
        }
      }
    ];

    this.frameworkComponentsClothesEploye = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelectionClothesEmploye = 'multiple';

  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscarClothes);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChangedClothesEmploye() {
    this.gridApiClothesEmploye.setQuickFilter(this.textoBuscarClothesEmploye);
  }

  onGridReadyClothesEmploye(params) {
    this.gridApiClothesEmploye = params.api;
    this.gridColumnApiClothesEmploye = params.columnApi;
  }

  llenarDatosEmpleado(){
    this.formulario.get('codigo').setValue(this.infoEmployeClothes.employee.codigo);
    this.formulario.get('ccosto').setValue(this.infoEmployeClothes.employee.ccosto);
    this.formulario.get('depart').setValue(this.infoEmployeClothes.employee.departamento);
    this.formulario.get('fullname').setValue(this.infoEmployeClothes.employee.nombres);
  }

  limpiarDatosEmpleado(){
    this.rowDataSend = [];
    this.rowData = [];
    this.gridApiClothesEmploye.setRowData(this.rowDataSend);
    this.gridApi.setRowData(this.rowData);
    this.formulario.get('codigo').setValue("");
    this.formulario.get('ccosto').setValue("");
    this.formulario.get('depart').setValue("");
    this.formulario.get('fullname').setValue("");
  }

  llenarClothesEmployeRowData(){
    debugger;
    this.infoEmployeClothes.clothesEmployes.forEach((item) => {
      let itemCE = new ClothesEmployeSendModel();
      itemCE.codbaan = item.pieza.codBaan;
      itemCE.descrp = item.pieza.descrp;
      itemCE.cantd = item.quantity;
      itemCE.disp = item.available;
      this.rowDataSend.push(itemCE);
    });
    this.gridApiClothesEmploye.setRowData(this.rowDataSend);
  }

  buscarInfoEmpleado(){
    this.limpiarDatosEmpleado();
    this._clotheEmploye.findInfoEmploye(this.formulario.get('cedula').value).subscribe((res:ResponseInfoClothesEmployeModel)=>{
      this.infoEmployeClothes = res;
      this.rowData = this.infoEmployeClothes.clothes;
      this.llenarDatosEmpleado();
      if(this.infoEmployeClothes.clothesEmployes.length > 0){
        this.llenarClothesEmployeRowData();
      }
      this._util.mensajeOKToast("Busqueda exitosa.");
      this.listaVacia = false;
    },(err)=>{
      console.log(err);
      this.limpiarDatosEmpleado();
      this.listaVacia = true;
      this.infoEmployeClothes = new ResponseInfoClothesEmployeModel();
      if(err.error.key == '500'){
        this._util.mensajeErroToast(err.error.message,3000);
      }else{
        this._util.mensajeErroToast('No se encontro información.');
      }
    });
  }

  callModalCantidad(event){
    this.seletedCLothesEmploye  = event.data;
    this.formularioCantidad.get('codbaan').setValue(this.seletedCLothesEmploye.codbaan)
    this.formularioCantidad.get('descrp').setValue(this.seletedCLothesEmploye.descrp)
    this.formularioCantidad.get('cantd').setValue(this.seletedCLothesEmploye.cantd)
    document.getElementById('abrirModalCantidad').click();
  }

  setCantidadClothesEmploye(){
    debugger;
    const index = this.rowDataSend.findIndex((e) => e.codbaan === this.seletedCLothesEmploye.codbaan);
    let data = this.seletedCLothesEmploye;
    if(this.seletedCLothesEmploye.cantd > this.seletedCLothesEmploye.disp){
      let diferencia = this.seletedCLothesEmploye.cantd - this.seletedCLothesEmploye.disp;
      data.disp = Number(this.formularioCantidad.get('cantd').value) - diferencia ;
    }
    else{
      data.disp = + this.formularioCantidad.get('cantd').value;
    }
    data.cantd = + this.formularioCantidad.get('cantd').value;
    this.rowDataSend.splice(index, 1, data);
    this.gridApiClothesEmploye.setRowData(this.rowDataSend);
    document.getElementById('cerrarModalCantidad').click();
  }

  addElementToClothesEmploye({rowData}){  
    let itemCE = new ClothesEmployeSendModel();
    itemCE.codbaan = rowData.codBaan;
    itemCE.descrp = rowData.descrp;
    itemCE.cantd = 0;
    itemCE.disp = 0;
    this.rowDataSend.push(itemCE);
    this.gridApiClothesEmploye.setRowData(this.rowDataSend);

    const index = this.rowData.findIndex((e) => e.codBaan === itemCE.codbaan);
    this.rowData.splice(index, 1);
    this.gridApi.setRowData(this.rowData);

  }

  addElementToClothes({rowData}){
    let item = new ClothesModel();
    item.codBaan = rowData.codbaan;
    item.descrp = rowData.descrp;
    item.grupoSz = "";
    item.punit = 0;
    this.rowData.push(item);
    this.gridApi.setRowData(this.rowData);

    const index = this.rowDataSend.findIndex((e) => e.codbaan === item.codBaan);
    this.rowDataSend.splice(index, 1);
    this.gridApiClothesEmploye.setRowData(this.rowDataSend);
  }

  resetQuotes(){
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea reiniciar las cuotas de prendas?',
        text: '',
        action: 'Renicio de Cupos',
        funcion: this._clotheEmploye.resteQuote(),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      this.limpiarDatosEmpleado();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  saveClothesEmployee(){
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea guardar las Prendas por Empleado?',
        text: '',
        action: 'Guardar',
        funcion: this._clotheEmploye.createEditClothesEmployee(this.infoEmployeClothes.employee.cedula, this.rowDataSend),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarDatosEmpleado();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formularioCarga.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formularioCarga.get('multipart').setValue(file);
      }
    }
  }

  setFormData(data: any) {
    const formData = new FormData();
    // formData.append('file', data.multipart)
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    return formData;
  }

  enviarFormulario() {
    this.limpiarDatosEmpleado();
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguientes Archivo?',
        text: '',
        action: 'Enviar',
        funcion: this._clotheEmploye.uploadFile(this.setFormData(this.formularioCarga.value)),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarDatosEmpleado();
      this.formularioCarga.reset();
      this.fileInput.nativeElement.value = '';
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.rowDataSend = [];
      this.listaVacia = true;
    });
  }

  printEntregas(){
    if(this.infoEmployeClothes.employee == undefined || this.infoEmployeClothes == null || this.infoEmployeClothes.employee.cedula == undefined || this.infoEmployeClothes.employee.cedula  == ''){
      this._util.mensajeErrorVisto('Debe propinar un número de cédula');
    }else{
      this._clotheEmploye.downloadEntrega(this.infoEmployeClothes.employee.cedula).subscribe((res:ClaveValorModel)=>{    
        this._util.descargarArchivo(res.clave, res.valor);
        this._util.mensajeOKToast("Descarga exitosa.");
      },(err)=>{
        console.log(err);
        this._util.mensajeErrorVisto("Descarga fallida.");
      });
    }
  }

}
